"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const styles_1 = require("@material-ui/core/styles");
exports.useStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    row: {
        boxSizing: 'border-box',
        borderBottom: '1px solid #cdcdcd',
        minWidth: '100%',
        minHeight: 30,
        '&:hover': {
            backgroundColor: theme.palette.highlight,
        },
        padding: '2px 16px',
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
    },
    tableRowActions: {
        flexShrink: 0,
        height: 20,
        verticalAlign: 'top',
        display: 'inline-block',
        padding: 0,
        overflow: 'hidden',
        '& svg': {
            cursor: 'pointer',
            width: 20,
            height: 20,
            padding: '2pt',
        },
    },
    cellWrapper: {
        flexShrink: 0,
        display: 'flex',
        paddingRight: 10,
        boxSizing: 'border-box',
    },
    tableActions: {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
        height: 30,
        width: '100%',
        boxSizing: 'border-box',
        verticalAlign: 'top',
        display: 'flex',
        padding: '0 12px',
        '& svg': {
            cursor: 'pointer',
            width: 20,
            height: 20,
            padding: '2pt',
        },
    },
    buttonGroup: {
        display: 'flex',
        marginLeft: -5,
    },
    rowDraggable: {
        alignSelf: 'center',
    },
}));
//# sourceMappingURL=inline-table-field-styles.js.map